/* eslint-disable no-lonely-if */

import components from './_components';
import methods from './_methods';
import permissionUser from '@/inheritance/permission-user';

// Mixins
import DatePickerMixin from '@/mixins/datepicker';
import DispatchersMixin from '@/mixins/dispatchers';
import LogoutMixin from '@/mixins/logout';

export default {
    name: 'IssueDetails',
    extends: permissionUser,
    mixins: [DatePickerMixin, DispatchersMixin, LogoutMixin],
    components,
    methods,

    data() {
        return {
            loading: false
        };
    },

    computed: {
        editingIssue() {
            if (this.actionObject('ISSUES', 'edit')) {
                return this.$route.query.edit || this.$route.name.includes('issues_add') ? true : false;
            }
            return false;
        }
    }
};
